export const REGISTER_FORM = "REGISTER_FORM";
